const palette = {
  /* primary */
  "primary-1": "#57afef",
  "primary-2": "#3aa3ef",
  "primary-3": "#1392ec",
  "primary-4": "#006ae6",
  "primary-5": "#0179d0",

  /* secondary */
  "secondary-1": "#EBB3F8",
  "secondary-2": "#D875F0",
  "secondary-3": "#C331E8",
  "secondary-4": "hsl(333deg 100% 45%)",
  "secondary-5": "#602994",

  /* gray */
  "gray-1": "#F3F5F7",
  "gray-2": "#BBC4CF",
  "gray-3": "#9EA8B3",
  "gray-4": "#818C99",
  "gray-5": "#778089",

  /* Unique color */
  "color-success": "#04a088",
  "color-error": "#DA3862",
  "color-warning": "#FBD348",

  /* opacity  */
  "opacity-gray": "rgba(174, 174, 174, 0.2)",
  "opacity-dark": "rgba(43, 31, 74, 0.73)",
} as const;

export default palette;
